Object.defineProperty(exports,"__esModule",{value:true});exports.label=exports.SECURITY_DEVICE_SECURITY_EXCEPTIONS=exports.SECURITY_DEVICE_HEALTH_EXCEPTIONS=exports.typeDisplay=exports.types=undefined;var _types=require('../armState/types');

var types=exports.types={
NOT_ON_POSITION:'not_on_position'};


var typeDisplay=exports.typeDisplay={
NOT_ON_POSITION:'Not On Position',
MISSING_SECURED_PRODUCT:'Missing Secured Product'};


var SECURITY_DEVICE_HEALTH_EXCEPTIONS=exports.SECURITY_DEVICE_HEALTH_EXCEPTIONS=[types.NOT_ON_POSITION];

var SECURITY_DEVICE_SECURITY_EXCEPTIONS=exports.SECURITY_DEVICE_SECURITY_EXCEPTIONS=[
_types.armState.DISARMED,
_types.armState.ALARMING];


var label=exports.label={
NOT_ON_POSITION:'Unmapped Puck'};